<template>
  <v-container :class="containerClass" fluid></v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
export default {
  layout: LayoutDashboard,
}
</script>
